export default "__VITE_ASSET__CNPoL3_d__"